export class IndexCrosswalk {
    crosswalk = new Map();

    constructor(arr: any[]) {
        this.initCrosswalk(arr);
    }

    getItem(id: string): any {
        return this.crosswalk.get(id);
    }

    setItem(id: string, value: any): void {
        let attrib = this.crosswalk.get(id);
        if (attrib) {
            attrib.attributes = value.attributes;
            attrib.type = value.type;
            attrib.name = value.name;
            attrib.partialFilterTql = value.partialFilterTql;

            // remove partialFilterTql if the new index type is not unique or normal.
            if (!(value?.type === 'UNIQUE' || value?.type === 'NORMAL')) {
                delete attrib.partialFilterTql;
            }
        }
    }

    // Fornow this has to be any to deal with  attributes vs nodeAttributes
    initCrosswalk = (arr: any[]): void => {
        for (const item of arr) {
            if (!item) return;
            const id = crypto.randomUUID();
            item.id = id;
            this.crosswalk.set(id, item);
        }
    };
}
